export const COMMIT_HASH = 'e10bf18c0c92d153027f0c2e37dee92ee0545729';
